import React from "react";
import Loading from "components/ui/Loading";
import { ApiIncomeTaxReturnStatus } from "utils/api/incomeTaxReturns";
import useTaxReturnsWithAdvance from "utils/hooks/useTaxReturnsWithAdvance";
import { PartnerSlug } from "types/general";
import TaxRefund from "./TaxRefund";
import TaxFilingRejected from "./TaxFilingRejected";

interface Props {
  partnerSlug?: PartnerSlug;
}

const TaxFilingSubmitted: React.FC<Props> = ({ partnerSlug }) => {
  const taxReturnsWithAdvance = useTaxReturnsWithAdvance();
  const { isLoading } = taxReturnsWithAdvance;

  const hasRejectedReturn = taxReturnsWithAdvance.taxReturns.some(
    (taxReturn) =>
      taxReturn.taxReturnStatus === ApiIncomeTaxReturnStatus.rejected
  );

  if (isLoading) return <Loading />;

  if (hasRejectedReturn) return <TaxFilingRejected />;

  return (
    <TaxRefund
      taxReturnsWithAdvance={taxReturnsWithAdvance}
      partnerSlug={partnerSlug}
    />
  );
};

export default TaxFilingSubmitted;
